import { defineComponent as _defineComponent } from 'vue'

import { defineComponent, computed, onMounted, onBeforeUnmount } from 'vue'
import { NuxtError } from '@nuxt/types'

import LButton from '@/components/core/Button.vue'
import { useContext } from '@/composables/context'
import Intercom from '@/utils/intercom-manager'

const __default__ = defineComponent({
  name: 'ErrorLayout',
  layout: 'error-layout',
  head() {
    return {
      title: `${this.$t('error.page.title')} - Lambus`,
    }
  },
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    error: null
  },
  setup(__props: any) {

const props = __props as {
  error: NuxtError
};



const { i18n } = useContext()

const errorTitle = computed(() => {
  switch (props.error.statusCode) {
    case 404:
      return i18n.t('error.notFound')
    case 500:
      return i18n.t('error.serverError')
    default:
      return i18n.t('error.generic')
  }
})

const errorSubtitle = computed(() => {
  switch (props.error.statusCode) {
    case 404:
      return i18n.t('error.notFoundSubtitle')
    default:
      return i18n.t('error.generic')
  }
})

function openIntercom() {
  Intercom.show()
}

onMounted(() => {
  Intercom.launch()
})

onBeforeUnmount(() => {
  Intercom.shutdown()
})

return { __sfc: true,props, i18n, errorTitle, errorSubtitle, openIntercom, LButton }
}

})